import React from 'react';

// Define the Alert component
const Alert = ({ type, message }) => {
  // Set the styles based on the type (success, error, etc.)
  const alertStyles = {
    success: 'bg-green-100 text-green-800 border-green-400',
    error: 'bg-red-100 text-red-800 border-red-400',
    warning: 'bg-yellow-100 text-yellow-800 border-yellow-400',
    info: 'bg-blue-100 text-blue-800 border-blue-400',
  };

  // Default to 'info' if type is not provided
  const alertClass = alertStyles[type] || alertStyles.info;

  return (
    <div className={`flex items-center p-4 border-l-4 ${alertClass} rounded-lg`}>
      <svg
        className="w-5 h-5 mr-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlSpace="preserve"
      >
        {/* Add icons for each alert type */}
        {type === 'success' && (
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 13l-3-3 1.5-1.5L9 10l4-4L15.5 7l-6 6z"
            clipRule="evenodd"
          />
        )}
        {type === 'error' && (
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 7l3 3 3-3 1.5 1.5-3 3 3 3-1.5 1.5-3-3-3 3-1.5-1.5 3-3-3-3z"
            clipRule="evenodd"
          />
        )}
        {type === 'warning' && (
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 12V6h2v6H9zM9 14h2v2H9z"
            clipRule="evenodd"
          />
        )}
        {type === 'info' && (
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 13h2v-2H9v2zM9 7h2V5H9v2z"
            clipRule="evenodd"
          />
        )}
      </svg>
      <div className="flex-1">
        <p className="font-medium">{message}</p>
      </div>
    </div>
  );
};

export default Alert;
